import { Dialog as MuiDialog } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Dialog = styled(MuiDialog)`
  width: 100%;
  height: 100%;
  z-index: 100000;

  .MuiDialog-container {
    .MuiPaper-root {
      width: 664px;
      max-width: 664px;
      height: 314px;
      background: ${theme.colors.surfaceContainerBackground};
      border-radius: ${theme.attributes.borderRadius.tertiary};
      padding: ${theme.spacing.large}px;

      .header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;
        margin-bottom: ${theme.spacing.medium}px;

        .header-title {
          flex: 1;
          font-family: ${theme.typography.fontFamily.primary};
          color: ${theme.colors.menuItemText};
          font-size: 28px;
          font-style: normal;
          font-weight: ${theme.typography.fontWeight.bold};
          line-height: 42px;
          text-align: center;
          padding-left: 42px;
        }

        .close-button {
          color: ${theme.colors.neutral100};
          padding: 0;
          width: 42px;
          height: 42px;

          &:hover {
            background: ${theme.baseColors.primary[20]};
            svg {
              path {
                fill: ${theme.colors.white};
              }
            }
          }
        }
      }

      .content {
        text-align: center;
        margin-bottom: 48px;

        .description {
          color: ${theme.colors.devicesSecondaryText};
          font-family: ${theme.typography.fontFamily.primary};
          font-size: ${theme.typography.fontSize.large};
          font-style: normal;
          font-weight: ${theme.typography.fontWeight.normal};
          line-height: 22px;
          letter-spacing: 0.25px;
        }
      }

      .footer {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: ${theme.spacing.xSmall}px;
      }
    }
  }

  html[data-theme='light'] & .MuiDialog-container .MuiPaper-root .close-button {
    color: ${theme.colors.devicesSecondaryText};

    svg path {
      fill: ${theme.colors.devicesSecondaryText};
    }
  }
`
